import React, { useContext } from 'react'
import styled from 'styled-components'
import { LanguageContext } from '../../i18n/LanguageContext'

const LANGUAGES = [
  { code: 'it', flag: '🇮🇹', label: 'IT' },
  { code: 'en', flag: '🇬🇧', label: 'EN' },
  { code: 'fr', flag: '🇫🇷', label: 'FR' }
]

const Container = styled.div`
  display: flex;
  gap: 0.375rem;
  align-items: center;
`

const LangButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  border: 1px solid ${props =>
    props.$active
      ? props.theme.colors.text.primary
      : props.theme.colors.border.medium};
  border-radius: 4px;
  background: ${props =>
    props.$active
      ? props.theme.colors.text.primary
      : 'transparent'};
  color: ${props =>
    props.$active
      ? props.theme.colors.background.primary
      : props.theme.colors.text.secondary};
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  line-height: 1;
  user-select: none;

  &:hover {
    border-color: ${props => props.theme.colors.text.primary};
    color: ${props =>
      props.$active
        ? props.theme.colors.background.primary
        : props.theme.colors.text.primary};
  }

  &:focus {
    outline: none;
  }
`

const Flag = styled.span`
  font-size: 1rem;
  line-height: 1;
`

const LanguageSelectorButtons = () => {
  const { language, setLanguage } = useContext(LanguageContext)

  return (
    <Container>
      {LANGUAGES.map(lang => (
        <LangButton
          key={lang.code}
          $active={language === lang.code}
          onClick={() => setLanguage(lang.code)}
          aria-label={lang.code.toUpperCase()}
          aria-pressed={language === lang.code}
        >
          <Flag aria-hidden='true'>{lang.flag}</Flag>
          <span>{lang.label}</span>
        </LangButton>
      ))}
    </Container>
  )
}

export default LanguageSelectorButtons
